import PropTypes from 'prop-types';
import React from 'react';

import defined from '~app/core/defined';
import { formatLicense } from '~app/core/license';

const WildlifeCitations = ({selectedSpeciesSummary, selectedSpeciesContent}) => {
  if (defined(selectedSpeciesSummary) &&
      defined(selectedSpeciesContent)) {
    return (
      <div className="WildlifeCitations">
        {renderContent(selectedSpeciesSummary, selectedSpeciesContent)}
      </div>
    );
  }
  return null;
};

function renderContent(speciesSummary, speciesContent) {
  return [
    renderTitle(),
    renderCitations(generateCitationRows(speciesSummary, speciesContent)),
  ];
}

function renderTitle() {
  return (
    <p key="title" className="WildlifeCitations__title">
      Citations
    </p>
  );
}

function renderCitations(citationRows) {
  return (
    <div key="citations" className="WildlifeCitations__citations">
      {citationRows.map(citationRow => renderCitation(citationRow.category, citationRow.citation))}
    </div>
  );
}

function renderCitation(category, citation) {
  return (
    <div key={category} className="WildlifeCitations__citationRow">
      <p className="WildlifeCitations__category">
        {`${category}: `}
      </p>
      <div className="WildlifeCitations__citation"
        dangerouslySetInnerHTML={{
          __html: citation,
        }}
      />
    </div>
  );
}

function generateCitationRows(speciesSummary, speciesContent) {

  let citationRows = [];

  let staticCitationRows = [
    generateThreatLevelCitation(),
    generatePresenceCitation(speciesSummary),
  ];
  citationRows.push(...staticCitationRows);

  if (defined(speciesContent.description_citation) &&
      defined(speciesContent.description_license) &&
      defined(speciesContent.description_source_url)) {

      let descriptionCitationRows = [
        generateDescriptionCitation(speciesContent),
        generateEolCitation(),
      ];
      citationRows.push(...descriptionCitationRows);
  }

  return citationRows;
}

function generateThreatLevelCitation() {
  return {
    "category": "Biology & Status",
    "citation": "IUCN 2016. The IUCN Red List of Threatened Species. Version 2016-1. " +
                "&lt;<a href=\"http://www.iucnredlist.org\" target=\"_blank\" rel=\"noopener\">" +
                "http://www.iucnredlist.org</a>&gt;. Downloaded on 7/29/2016.",
  };
}

function generatePresenceCitation(speciesSummary) {
  return {
    "category": "Presence",
    "citation": formatPresenceCredit(speciesSummary),
  };
}

function generateDescriptionCitation(speciesContent) {
  return {
    "category": "Description",
    "citation": formatDescriptionCredit(speciesContent),
  };
}

function generateEolCitation() {
  return {
    "category": "Content Provider",
    "citation": "Encyclopedia of Life. Available from " +
                "<a href=\"http://www.eol.org\" target=\"_blank\" rel=\"noopener\">http://www.eol.org</a>. " +
                "Accessed 11/2/2016.",
  };
}

function formatPresenceCredit(speciesSummary) {
  // Format the credit.
  let creditText = "";
  if (defined(speciesSummary.region_citation) &&
      speciesSummary.region_citation.length > 0) {

    creditText = speciesSummary.region_citation.slice(0);
    if (creditText.charAt(creditText.length - 1) !== '.') {
      // If the credit does not end in a period, we must add one.
      creditText = creditText.concat(".");
    }
    // Always add a space after a non-empty credit.
    creditText = creditText.concat(" ");
  }

  // Format the compiled date.
  let dateText = "";
  if (defined(speciesSummary.region_compiled_year) &&
      speciesSummary.region_compiled_year !== 0) {

    dateText = speciesSummary.region_compiled_year.toString();
    if (dateText.charAt(dateText.length - 1) !== '.') {
      // If the date does not end in a period, we must add one.
      dateText = dateText.concat(".");
    }
    // Always add a space after a non-empty date.
    dateText = dateText.concat(" ");
  }

  // Format the updated date.
  let updateText = "";
  if (defined(speciesSummary.region_updated_date)) {
    // Start with a space because this date goes at the end of our fixed citation string.
    updateText = ` Downloaded on ${formatDate(speciesSummary.region_updated_date)}.`;
  }

  return `${creditText}${dateText}IUCN 2014. \
The IUCN Red List of Threatened Species. Version 2014-1. \
<a href="http://www.iucnredlist.org" target="_blank" rel="noopener">\
"http://www.iucnredlist.org</a>.\
${updateText}`;
}

function formatDescriptionCredit(speciesContent) {
  return `${speciesContent.description_citation}. \
<a href=${speciesContent.description_license} target="_blank" rel="noopener">\
${formatLicense(speciesContent.description_license)}</a> \
<a href=${speciesContent.description_source_url} target="_blank" rel="noopener">\
View online</a>. \
Last accessed on ${formatDate(speciesContent.description_updated_date)}.`;
}

function formatDate(rawDate) {
  const date = new Date(rawDate * 1000);
  return date.toLocaleDateString({
    month: "numeric",
    day: "numeric",
    year: "2-digit",
  });
}

WildlifeCitations.propTypes = {
  selectedSpeciesSummary: PropTypes.object,
  selectedSpeciesContent: PropTypes.object,
};

export default WildlifeCitations;



// WEBPACK FOOTER //
// ./src/components/WildlifeCitations.js